"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthButton = void 0;
const react_1 = __importStar(require("react"));
const DatetimeInput_1 = require("../../../controls/DatetimeInput");
const DatetimeInputContext_1 = require("../../../controls/DatetimeInput/context/DatetimeInputContext");
const SelectableItem_1 = require("../../../helpers/components/SelectableItem/SelectableItem");
exports.MonthButton = react_1.default.memo(function MonthButton({ value, selectedValue, disabled, onSelect, texts, ['data-selector-id']: dataSelectorId }) {
    const SHORT_MONTHS = (0, react_1.useMemo)(() => ({
        0: texts.shortJanuary,
        1: texts.shortFebruary,
        2: texts.shortMarch,
        3: texts.shortApril,
        4: texts.shortMay,
        5: texts.shortJune,
        6: texts.shortJuly,
        7: texts.shortAugust,
        8: texts.shortSeptember,
        9: texts.shortOctober,
        10: texts.shortNovember,
        11: texts.shortDecember
    }), [
        texts.shortApril,
        texts.shortAugust,
        texts.shortDecember,
        texts.shortFebruary,
        texts.shortJanuary,
        texts.shortJuly,
        texts.shortJune,
        texts.shortMarch,
        texts.shortMay,
        texts.shortNovember,
        texts.shortOctober,
        texts.shortSeptember
    ]);
    const context = (0, react_1.useContext)(DatetimeInputContext_1.DatetimeInputContext);
    const now = (context === null || context === void 0 ? void 0 : context.getNowTime)
        ? context === null || context === void 0 ? void 0 : context.getNowTime()
        : (0, DatetimeInput_1.getDateWithOffset)(new Date(), context.serverUtcOffset);
    return (react_1.default.createElement(SelectableItem_1.SelectableItem, { value: SHORT_MONTHS[value], isCurrentMonth: true, selected: selectedValue === value, disabled: disabled, isToday: now.getMonth() === value, onClick: () => onSelect(value), "data-selector-id": dataSelectorId, showCurrentDate: true }));
});
//# sourceMappingURL=MonthButton.js.map